export default __webpack_public_path__ + "static/media/calendar.6b496164.svg";